"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _OldLinkBannerDesktop = require("./OldLinkBannerDesktop");
Object.keys(_OldLinkBannerDesktop).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OldLinkBannerDesktop[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _OldLinkBannerDesktop[key];
    }
  });
});